import { render, staticRenderFns } from "./CommunityHealthinfoCard.vue?vue&type=template&id=cab81f2c&scoped=true"
import script from "./CommunityHealthinfoCard.vue?vue&type=script&lang=js"
export * from "./CommunityHealthinfoCard.vue?vue&type=script&lang=js"
import style0 from "./CommunityHealthinfoCard.vue?vue&type=style&index=0&id=cab81f2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cab81f2c",
  null
  
)

export default component.exports